import React from 'react';
import Alert from '@amzn/meridian/alert';

/**
 * Persistent advisory banner shown above the Luminous contact-reading view.
 *
 * Customer transcripts surfaced here may still contain personal data that automated scrubbing
 * cannot catch (e.g. names or addresses embedded in free-form text). This banner reminds analysts
 * of their data-handling obligations: view in-tool only, never copy/paste/export PII elsewhere.
 *
 * Rendered on the contact-reading surface, alongside the contact-lookup form and under the same
 * CONTACT_LOOKUP_ACCESS gate (see App.js, P449218527).
 */
const PiiNotice = () => (
  <Alert type="warning" size="medium">
    <strong>Handling customer data:</strong> Transcripts shown here may contain customer personal data (PII). Common
    structured PII (cards, phone numbers, emails, etc.) is redacted where detected, but redaction is not guaranteed to
    be complete — names, addresses, and other details may remain. Treat every field as potentially containing PII. Do
    not copy, paste, screenshot, export, or otherwise move this data outside this tool. Use it only for the task at
    hand, within Luminous.
  </Alert>
);

export default PiiNotice;
